/** Maps timeline filter category → event types for client-side filtering */
export const FILTER_CATEGORIES: Record<string, string[]> = {
  communication: ['sms_sent', 'email_sent'],
  status: ['status_changed', 'status_change', 'order_prepared', 'order_delivered', 'delivery_confirmed'],
  parts: [
    'purchase_order_created', 'purchase_order_sent', 'purchase_order_received',
    'purchase_order_partial', 'purchase_order_email_sent', 'lines_added', 'lines_removed',
  ],
  erp: [
    'order_created', 'order_updated', 'erp_sync', 'erp_created',
    'info_changed', 'reference_changed', 'your_ref_changed',
    'delivery_date_changed', 'shipping_changed',
  ],
}
